import React from "react";
import { Tab as DsmTab } from "@plum-xoxo/admin-dsm";

const TabElement = (props) => {
  return <DsmTab {...props}>{props.children}</DsmTab>;
};

export default TabElement;
